module.exports = __webpack_public_path__ + "media/components/insights/asset-icons/reputation-c406572db5dcace4492270273cd40c2c.png";